import FroalaEditor from 'froala-editor';
import { StaticLocalization } from '../localizedStrings';

(function (SA) {
  let localizedStrings = new StaticLocalization().strings;
  Object.assign(SA.POPUP_TEMPLATES, {
    'showArticle.editArticle': '[_BUTTONS_]',
    'showArticle.insertArticle': '[_BUTTONS_][_INPUT_LAYER_]',
  });
  Object.assign(SA.DEFAULTS, {
    linkEditButtons: ['linkOpenArticle', 'articleLinkEdit', 'linkArticleRemove'],
    linkInsertButtons: ['linkArticleBack', '|'],
    linkAttributes: {},
    linkAutoPrefix: 'http://',
    linkMultipleStyles: false,
    linkNoOpener: true,
    linkNoReferrer: true,
    linkText: true,
  });

  SA.PLUGINS.showArticle = function (editor) {
    var $ = editor.$;
    function get() {
      var $current_image = editor.image ? editor.image.get() : null;
      if ($current_image || !editor.$wp) {
        if (editor.el.tagName === 'A') {
          return editor.el;
        } else {
          if ($current_image && $current_image.get(0).parentNode && $current_image.get(0).parentNode.tagName === 'A') {
            return $current_image.get(0).parentNode;
          }
        }
      }
      var c_el = editor.selection.ranges(0).commonAncestorContainer;

      try {
        if (c_el && ((c_el.contains && c_el.contains(editor.el)) || !editor.el.contains(c_el) || editor.el === c_el))
          c_el = null;
      } catch (ex) {
        c_el = null;
      }

      if (c_el && c_el.tagName === 'A') return c_el;
      var s_el = editor.selection.element();
      var e_el = editor.selection.endElement();

      if (s_el.tagName !== 'A' && !editor.node.isElement(s_el)) {
        s_el = $(s_el).parentsUntil(editor.$el, 'a').get(0);
      }

      if (e_el.tagName !== 'A' && !editor.node.isElement(e_el)) {
        e_el = $(e_el).parentsUntil(editor.$el, 'a').get(0);
      }

      try {
        if (e_el && ((e_el.contains && e_el.contains(editor.el)) || !editor.el.contains(e_el) || editor.el === e_el))
          e_el = null;
      } catch (ex) {
        e_el = null;
      }

      try {
        if (s_el && ((s_el.contains && s_el.contains(editor.el)) || !editor.el.contains(s_el) || editor.el === s_el))
          s_el = null;
      } catch (ex) {
        s_el = null;
      }

      if (e_el && e_el === s_el && e_el.tagName === 'A') {
        // We do not clicking at the end / input of links because in IE the selection is changing shortly after mouseup.
        // https://jsfiddle.net/jredzam3/
        if (
          (editor.browser.msie || editor.helpers.isMobile()) &&
          (editor.selection.info(s_el).atEnd || editor.selection.info(s_el).atStart)
        ) {
          return null;
        }

        return s_el;
      }

      return null;
    }

    function allSelected() {
      var $current_image = editor.image ? editor.image.get() : null;
      var selectedLinks = [];

      if ($current_image) {
        if ($current_image.get(0).parentNode.tagName === 'A') {
          selectedLinks.push($current_image.get(0).parentNode);
        }
      } else {
        var range;
        var containerEl;
        var links;
        var linkRange;

        if (editor.win.getSelection) {
          var sel = editor.win.getSelection();

          if (sel.getRangeAt && sel.rangeCount) {
            linkRange = editor.doc.createRange();

            for (var r = 0; r < sel.rangeCount; ++r) {
              range = sel.getRangeAt(r);
              containerEl = range.commonAncestorContainer;

              if (containerEl && containerEl.nodeType !== 1) {
                containerEl = containerEl.parentNode;
              }

              if (containerEl && containerEl.nodeName.toLowerCase() === 'a') {
                selectedLinks.push(containerEl);
              } else {
                links = containerEl.getElementsByTagName('a');

                for (var i = 0; i < links.length; ++i) {
                  linkRange.selectNodeContents(links[i]);

                  if (
                    linkRange.compareBoundaryPoints(range.END_TO_START, range) < 1 &&
                    linkRange.compareBoundaryPoints(range.START_TO_END, range) > -1
                  ) {
                    selectedLinks.push(links[i]);
                  }
                }
              }
            }

            // linkRange.detach();
          }
        } else if (editor.doc.selection && editor.doc.selection.type !== 'Control') {
          range = editor.doc.selection.createRange();
          containerEl = range.parentElement();

          if (containerEl.nodeName.toLowerCase() === 'a') {
            selectedLinks.push(containerEl);
          } else {
            links = containerEl.getElementsByTagName('a');
            linkRange = editor.doc.body.createTextRange();

            for (var j = 0; j < links.length; ++j) {
              linkRange.moveToElementText(links[j]);

              if (
                linkRange.compareEndPoints('StartToEnd', range) > -1 &&
                linkRange.compareEndPoints('EndToStart', range) < 1
              ) {
                selectedLinks.push(links[j]);
              }
            }
          }
        }
      }

      return selectedLinks;
    }

    function _edit(e) {
      if (editor.core.hasFocus()) {
        _hideEditPopup();

        // Do not show edit popup for link when ALT is hit.
        if (e && e.type === 'keyup' && (e.altKey || e.which === SA.KEYCODE.ALT)) return true;

        setTimeout(
          function () {
            // No event passed.
            // Event passed and (left click or other event type).
            if (!e || (e && (e.which === 1 || e.type !== 'mouseup'))) {
              var link = get();
              var $current_image = editor.image ? editor.image.get() : null;

              if (link && !$current_image) {
                if (editor.image) {
                  var contents = editor.node.contents(link);

                  // https://github.com/froala/wysiwyg-editor/issues/1103
                  if (contents.length === 1 && contents[0].tagName === 'IMG') {
                    var range = editor.selection.ranges(0);

                    if (range.startOffset === 0 && range.endOffset === 0) {
                      $(link).before(SA.INVISIBLE_SPACE + SA.MARKERS);
                    } else {
                      $(link).after(SA.INVISIBLE_SPACE + SA.MARKERS);
                    }

                    editor.selection.restore();

                    return false;
                  }
                }

                if (e) {
                  e.stopPropagation();
                }
                _showEditPopup(link);
              }
            }
          },
          editor.helpers.isIOS() ? 100 : 0,
        );
      }
    }

    function _showEditPopup(link) {
      var $popup = editor.popups.get('showArticle.editArticle');

      if (!$popup) $popup = _initEditPopup();

      var $link = $(link);

      if (!editor.popups.isVisible('showArticle.editArticle')) {
        editor.popups.refresh('showArticle.editArticle');
      }
      editor.popups.setContainer('showArticle.editArticle', editor.$sc);
      var left = $link.offset().left + $(link).outerWidth() / 2;
      var top = $link.offset().top + $link.outerHeight();
      editor.popups.show('showArticle.editArticle', left, top, $link.outerHeight(), true);
    }

    function _hideEditPopup() {
      editor.popups.hide('showArticle.editArticle');
    }

    function _initEditPopup() {
      // Link buttons.
      var link_buttons = '';

      if (editor.opts.linkEditButtons.length >= 1) {
        if (editor.el.tagName === 'A' && editor.opts.linkEditButtons.indexOf('linkArticleRemove') >= 0) {
          editor.opts.linkEditButtons.splice(editor.opts.linkEditButtons.indexOf('linkArticleRemove'), 1);
        }

        link_buttons = '<div class="fr-buttons">' + editor.button.buildList(editor.opts.linkEditButtons) + '</div>';
      }

      var template = {
        buttons: link_buttons,
      };

      // Set the template in the popup.
      var $popup = editor.popups.create('showArticle.editArticle', template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, 'scroll.link-edit', function () {
          if (get() && editor.popups.isVisible('showArticle.editArticle')) {
            _showEditPopup(get());
          }
        });
      }

      return $popup;
    }

    function _refreshInsertPopup() {
      var $popup = editor.popups.get('showArticle.insertArticle');
      var link = get();

      if (link) {
        var $link = $(link);
        var text_inputs = $popup.find('input.fr-link-attr[type="text"]');
        var check_inputs = $popup.find('input.fr-link-attr[type="checkbox"]');
        var i;
        var $input;

        for (i = 0; i < text_inputs.length; i++) {
          $input = $(text_inputs[i]);
          if ($link[i]) {
            $input.val($link[i].href || '');
          } else {
            $input.val($link.attr($input.attr('name') || ''));
          }
        }

        check_inputs.attr('checked', false);

        for (i = 0; i < check_inputs.length; i++) {
          $input = $(check_inputs[i]);

          if ($link.attr($input.attr('name')) === $input.data('checked')) {
            $input.attr('checked', true);
          }
        }

        $popup.find('input.fr-link-attr[type="text"][name="text"]').val($link.text());
      } else {
        $popup.find('input.fr-link-attr[type="text"]').val('');
        $popup.find('input.fr-link-attr[type="checkbox"]').attr('checked', false);
        $popup.find('input.fr-link-attr[type="text"][name="text"]').val(editor.selection.text());
      }
      $popup.find('input.fr-link-attr').trigger('change');
      var $current_image = editor.image ? editor.image.get() : null;

      if ($current_image) {
        $popup.find('.fr-link-attr[name="text"]').parent().hide();
      } else {
        $popup.find('.fr-link-attr[name="text"]').parent().show();
      }
    }

    function _showInsertPopup() {
      var $btn = editor.$tb.find('.fr-command[data-cmd="showArticle"]');
      var $popup = editor.popups.get('showArticle.insertArticle');

      if (!$popup) $popup = _initInsertPopup();

      if (!$popup.hasClass('fr-active')) {
        editor.popups.refresh('showArticle.insertArticle');
        editor.popups.setContainer('showArticle.insertArticle', editor.$tb || editor.$sc);

        if ($btn.isVisible()) {
          var n = editor.button.getPosition($btn);
          var left = n.left;
          var top = n.top;
          editor.popups.show('showArticle.insertArticle', left, top, $btn.outerHeight());
        } else {
          editor.position.forSelection($popup);
          editor.popups.show('showArticle.insertArticle');
        }
      }
    }

    function _initInsertPopup(delayed) {
      if (delayed) {
        editor.popups.onRefresh('showArticle.insertArticle', _refreshInsertPopup);

        return true;
      }

      // Image buttons.
      var link_buttons = '';

      if (editor.opts.linkInsertButtons.length >= 1) {
        link_buttons =
          '<div class="fr-buttons fr-tabs">' + editor.button.buildList(editor.opts.linkInsertButtons) + '</div>';
      }

      // Image by url layer.
      var input_layer = '';
      var tab_idx = 0;
      input_layer =
        '<div class="fr-link--insert-layer fr-layer fr-active" id="fr-link--insert-layer-' + editor.id + '">';
      input_layer +=
        '<div class="fr-input-line"><input id="fr-link--insert-layer-url-' +
        editor.id +
        '" name="href" type="text" class="fr-link-attr" placeholder="' +
        editor.language.translate('URL') +
        '" tabIndex="' +
        ++tab_idx +
        '"></div>';

      if (editor.opts.linkText) {
        input_layer +=
          '<div class="fr-input-line"><input id="fr-link--insert-layer-text-' +
          editor.id +
          '" name="text" type="text" class="fr-link-attr" placeholder="' +
          editor.language.translate('Text') +
          '" tabIndex="' +
          ++tab_idx +
          '"></div>';
      }

      input_layer +=
        '<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="linkInsertArticle" href="#" tabIndex="' +
        ++tab_idx +
        '" type="button">' +
        editor.language.translate('Insert') +
        '</button></div></div>';

      var template = {
        buttons: link_buttons,
        input_layer: input_layer,
      };

      // Set the template in the popup.
      var $popup = editor.popups.create('showArticle.insertArticle', template);

      if (editor.$wp) {
        editor.events.$on(editor.$wp, 'scroll.link-insert', function () {
          if (get && editor.popups.isVisible('showArticle.insertArticle')) {
            update();
          }
        });
      }

      return $popup;
    }

    function remove() {
      var link = get();

      var $current_image = editor.image ? editor.image.get() : null;

      if (editor.events.trigger('showArticle.beforeRemove', [link]) === false) return false;

      if ($current_image && link) {
        if (editor.image.hasCaption()) {
          $current_image.addClass('img-link-caption');
          $(link).replaceWith($(link).html());
          var n = document.querySelectorAll('img.img-link-caption');
          editor.image.edit($(n[0]));
          $(n[0]).removeClass('img-link-caption');
        } else {
          $current_image.unwrap();
          editor.image.edit($current_image);
        }
      } else if (link) {
        editor.selection.save();
        $(link).replaceWith($(link).html());
        editor.selection.restore();
        _hideEditPopup();
      }
    }

    function _init() {
      // Edit on keyup.
      editor.events.on('keyup', function (e) {
        if (e.which !== SA.KEYCODE.ESC) {
          _edit(e);
        }
      });

      editor.events.on('window.mouseup', _edit);

      // Do not follow links when edit is disabled.
      editor.events.$on(editor.$el, 'click', 'a', function (e) {
        if (editor.edit.isDisabled()) {
          e.preventDefault();
        }
      });

      if (editor.helpers.isMobile()) {
        editor.events.$on(editor.$doc, 'selectionchange', _edit);
      }

      _initInsertPopup(true);

      // Init on link.
      if (editor.el.tagName === 'A') {
        editor.$el.addClass('fr-view');
      }

      // Hit ESC when focus is in link edit popup.
      editor.events.on(
        'toolbar.esc',
        function () {
          if (editor.popups.isVisible('showArticle.editArticle')) {
            editor.events.disableBlur();
            editor.events.focus();

            return false;
          }
        },
        true,
      );
    }

    function insertArticleCallback() {
      var $popup = editor.popups.get('showArticle.insertArticle');
      var text_inputs = $popup.find('input.fr-link-attr[type="text"]');
      var check_inputs = $popup.find('input.fr-link-attr[type="checkbox"]');
      var href = (text_inputs.filter('[name="href"]').val() || '').trim();
      var text = editor.opts.linkText ? text_inputs.filter('[name="text"]').val() : '';
      var attrs = { 'data-show': 'showArticle' };
      var $input;
      var i;

      for (i = 0; i < text_inputs.length; i++) {
        $input = $(text_inputs[i]);

        if (['href', 'text'].indexOf($input.attr('name')) < 0) {
          attrs[$input.attr('name')] = $input.val();
        }
      }

      for (i = 0; i < check_inputs.length; i++) {
        $input = $(check_inputs[i]);

        if ($input.is(':checked')) {
          attrs[$input.attr('name')] = $input.data('checked');
        } else {
          attrs[$input.attr('name')] = $input.data('unchecked') || null;
        }
      }

      var t = editor.helpers.scrollTop();

      insert(href, text, attrs);
      $(editor.o_win).scrollTop(t);
    }

    function _split() {
      if (!editor.selection.isCollapsed()) {
        editor.selection.save();
        var markers = editor.$el.find('.fr-marker').addClass('fr-unprocessed').toArray();

        while (markers.length) {
          var $marker = $(markers.pop());
          $marker.removeClass('fr-unprocessed');

          // Get deepest parent.
          var deep_parent = editor.node.deepestParent($marker.get(0));

          if (deep_parent) {
            var node = $marker.get(0);
            var close_str = '';
            var open_str = '';

            do {
              node = node.parentNode;

              if (!editor.node.isBlock(node)) {
                close_str = close_str + editor.node.closeTagString(node);
                open_str = editor.node.openTagString(node) + open_str;
              }
            } while (node !== deep_parent);

            var marker_str =
              editor.node.openTagString($marker.get(0)) + $marker.html() + editor.node.closeTagString($marker.get(0));

            $marker.replaceWith('<span id="fr-break"></span>');
            var h = deep_parent.outerHTML;

            h = h
              .replace(/<span id="fr-break"><\/span>/g, close_str + marker_str + open_str)
              .replace(open_str + close_str, '');

            deep_parent.outerHTML = h;
          }

          markers = editor.$el.find('.fr-marker.fr-unprocessed').toArray();
        }

        editor.html.cleanEmptyTags();

        editor.selection.restore();
      }
    }

    /**
     * Insert link into the editor.
     */
    function insert(href, text, attrs) {
      if (editor.opts.trackChangesEnabled) {
        editor.edit.on();
        editor.events.focus(true);
        editor.undo.saveStep();
        editor.markers.insert();
        editor.html.wrap();
        if (!editor.$el.find('.fr-marker').length) {
          return void editor.popups.hide('showArticle.insertArticle');
        }
        editor.markers.remove();
      }

      if (typeof attrs === 'undefined') attrs = {};

      // if (editor.events.trigger('link.beforeInsert', [href, text, attrs]) === false) return false;
      if (href.indexOf('#') < 0) {
        ({ href, text, attrs } = editor.events.trigger('showArticle.beforeInsert', [href, text, attrs]));
      }

      // Get image if we have one selected.
      var $current_image = editor.image ? editor.image.get() : null;

      if (!$current_image && editor.el.tagName !== 'A') {
        editor.selection.restore();
        editor.popups.hide('showArticle.insertArticle');
      } else if (editor.el.tagName === 'A') {
        editor.$el.focus();
      }

      var original_href = href;

      // Convert email address.
      if (editor.opts.linkConvertEmailAddress) {
        if (editor.helpers.isEmail(href) && !/^mailto:.*/i.test(href)) {
          href = 'mailto:' + href;
        }
      }

      // Check if is local path.
      var local_path = /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i;

      // Add autoprefix.
      if (
        editor.opts.linkAutoPrefix !== '' &&
        !new RegExp('^(' + SA.LinkProtocols.join('|') + '):.', 'i').test(href) &&
        !/^data:image.*/i.test(href) &&
        !/^(https?:|ftps?:|file:|)\/\//i.test(href) &&
        !local_path.test(href)
      ) {
        // Do prefix only if starting character is not absolute.
        if (['/', '{', '[', '#', '(', '.'].indexOf((href || '')[0]) < 0) {
          href = editor.opts.linkAutoPrefix + href;
        }
      }

      // Sanitize the URL.
      href = editor.helpers.sanitizeURL(href);
      // Default attributs.
      attrs = { 'data-show': 'article' };

      // Format text.
      text = text || '';

      if (href === editor.opts.linkAutoPrefix) {
        var $popup = editor.popups.get('showArticle.insertArticle');
        $popup.find('input[name="href"]').addClass('fr-error');
        editor.events.trigger('showArticle.bad', [original_href]);

        return false;
      }

      // Check if we have selection only in one link.
      var link = get();
      var $link;

      if (link) {
        $link = $(link);
        $link.attr('href', href);
        $link.attr('data-show', 'showArticle');
        // Change text if it is different.
        if (text.length > 0 && $link.text() !== text && !$current_image) {
          if (editor.opts.trackChangesEnabled) {
            var s = $($link.get(0).outerHTML);
            s.insertBefore($link.parent());
            var o = editor.track_changes.wrapLinkInTracking(s, editor.track_changes.getPendingChanges().length - 1);
            var p = editor.track_changes.wrapInDelete(o);
            $link.parent().append(p);
          }

          var child = $link.get(0);

          while (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.ELEMENT_NODE) {
            child = child.childNodes[0];
          }

          $(child).text(text);
        }

        if (!$current_image) {
          $link.prepend(SA.START_MARKER).append(SA.END_MARKER);
        }

        // Set attributes.
        for (var f in attrs) attrs[f] ? $link.attr(f, attrs[f]) : $link.removeAttr(f);

        if (!$current_image) {
          editor.selection.restore();
        }
      } else {
        // We don't have any image selected.
        if (!$current_image) {
          // Remove current links.
          editor.format.remove('a');

          // Nothing is selected.
          if (editor.selection.isCollapsed()) {
            text = text.length === 0 ? original_href : text;
            editor.html.insert(
              '<a href="' +
                href +
                '">' +
                SA.START_MARKER +
                text.replace(/&/g, '&amp;').replace(/</, '&lt;', '>', '&gt;') +
                SA.END_MARKER +
                '</a>',
            );
            editor.selection.restore();
          } else {
            if (text.length > 0 && text !== editor.selection.text().replace(/\n/g, '')) {
              editor.selection.remove();
              editor.html.insert(
                '<a href="' + href + '">' + SA.START_MARKER + text.replace(/&/g, '&amp;') + SA.END_MARKER + '</a>',
              );
              editor.selection.restore();
            } else {
              _split();

              // Add link.
              editor.format.apply('a', { href: href });
            }
          }
        } else {
          // Just wrap current image with a link.
          $current_image.wrap('<a href="' + href + '"></a>');
          editor.image.hasCaption() &&
            $current_image.parent().append($current_image.parents('.fr-img-caption').find('.fr-inner'));
        }

        // Set attributes.
        var links = allSelected();

        for (var i = 0; i < links.length; i++) {
          $link = $(links[i]);
          $link.attr(attrs);
          $link.removeAttr('_moz_dirty');
        }

        // Show link edit if only one link.
        if (links.length === 1 && editor.$wp && !$current_image) {
          $(links[0]).prepend(SA.START_MARKER).append(SA.END_MARKER);

          editor.selection.restore();
        }
      }

      // Hide popup and try to edit.
      if (!$current_image) {
        _edit();
      } else {
        var $pop = editor.popups.get('showArticle.insertArticle');

        if ($pop) {
          $pop.find('input:focus').blur();
        }

        editor.image.edit($current_image);
      }
    }

    function update() {
      _hideEditPopup();

      var link = get();
      if (link) {
        var $popup = editor.popups.get('showArticle.insertArticle');

        if (!$popup) $popup = _initInsertPopup();

        if (!editor.popups.isVisible('showArticle.insertArticle')) {
          editor.popups.refresh('showArticle.insertArticle');
          editor.selection.save();

          if (editor.helpers.isMobile()) {
            editor.events.disableBlur();
            editor.$el.blur();
            editor.events.enableBlur();
          }
        }

        editor.popups.setContainer('showArticle.insertArticle', editor.$sc);
        var $ref = (editor.image ? editor.image.get() : null) || $(link);
        var left = $ref.offset().left + $ref.outerWidth() / 2;
        var top = $ref.offset().top + $ref.outerHeight();
        editor.popups.show('lishowArticlenk.insertArticle', left, top, $ref.outerHeight(), true);
      }
    }

    function back() {
      var $current_image = editor.image ? editor.image.get() : null;

      if (!$current_image) {
        editor.events.disableBlur();
        editor.selection.restore();
        editor.events.enableBlur();

        var link = get();

        if (link && editor.$wp) {
          editor.selection.restore();
          _hideEditPopup();
          _edit();
        } else if (editor.el.tagName === 'A') {
          editor.$el.focus();
          _edit();
        } else {
          editor.popups.hide('showArticle.insertArticle');
          editor.toolbar.showInline();
        }
      } else {
        editor.image.back();
      }
    }

    /**
     * Apply specific style.
     */
    function applyStyle(val, linkStyles, multipleStyles) {
      if (typeof multipleStyles == 'undefined') multipleStyles = editor.opts.linkMultipleStyles;

      if (typeof linkStyles == 'undefined') linkStyles = editor.opts.linkStyles;
      var link = get();

      if (!link) return false;

      // Remove multiple styles.
      if (!multipleStyles) {
        var styles = Object.keys(linkStyles);
        styles.splice(styles.indexOf(val), 1);
        $(link).removeClass(styles.join(' '));
      }

      $(link).toggleClass(val);

      _edit();
    }

    return {
      _init: _init,
      remove: remove,
      showInsertPopup: _showInsertPopup,
      insertArticleCallback: insertArticleCallback,
      insert: insert,
      update: update,
      get: get,
      allSelected: allSelected,
      back: back,
      applyStyle: applyStyle,
    };
  };

  // Register the link command.
  SA.DefineIconTemplate(
    'showArticle',
    '<svg xmlns="http://www.w3.org/2000/svg" width="40%" height="40%" viewBox="0 0 384 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"/></svg>',
  );
  SA.DefineIcon('showArticle', { template: 'showArticle' });
  SA.RegisterShortcut(SA.KEYCODE.Y, 'showArticle', null, 'Y');
  SA.RegisterCommand('showArticle', {
    title: localizedStrings.global.insertArticle,
    undo: false,
    focus: true,
    refreshOnCallback: false,
    popup: true,
    callback: function () {
      if (!this.popups.isVisible('showArticle.insertArticle')) {
        this.showArticle.showInsertPopup();
      } else {
        if (this.$el.find('.fr-marker').length) {
          this.events.disableBlur();
          this.selection.restore();
        }
        this.popups.hide('showArticle.insertArticle');
      }
    },
    plugin: 'showArticle',
  });

  SA.DefineIcon('linkOpenArticle', {
    NAME: 'external-link',
    FA5NAME: 'external-link-alt',
    SVG_KEY: 'openLink',
  });
  SA.RegisterCommand('linkOpenArticle', {
    title: 'Open Link',
    undo: false,
    refresh: function ($btn) {
      var link = this.showArticle.get();

      if (link) {
        $btn.removeClass('fr-hidden');
      } else {
        $btn.addClass('fr-hidden');
      }
    },
    callback: function () {
      var link = this.showArticle.get();
      if (link) {
        if (!link.target) link.target = '_self';
        if (this.browser.msie || this.browser.edge) {
          this.o_win.open(link.href, link.target);
        } else this.o_win.open(link.href, link.target, 'noopener');

        this.popups.hide('showArticle.editArticle');
      }
    },
    plugin: 'showArticle',
  });

  SA.DefineIcon('articleLinkEdit', { NAME: 'edit', SVG_KEY: 'edit' });
  SA.RegisterCommand('articleLinkEdit', {
    title: 'Edit Link',
    undo: false,
    refreshAfterCallback: false,
    popup: true,
    callback: function () {
      this.showArticle.update();
    },
    refresh: function ($btn) {
      var link = this.showArticle.get();

      if (link) {
        $btn.removeClass('fr-hidden');
      } else {
        $btn.addClass('fr-hidden');
      }
    },
    plugin: 'showArticle',
  });

  SA.DefineIcon('linkArticleRemove', { NAME: 'unlink', SVG_KEY: 'unlink' });
  SA.RegisterCommand('linkArticleRemove', {
    title: 'Unlink',
    callback: function () {
      this.showArticle.remove();
    },
    refresh: function ($btn) {
      var link = this.showArticle.get();

      if (link) {
        $btn.removeClass('fr-hidden');
      } else {
        $btn.addClass('fr-hidden');
      }
    },
    plugin: 'showArticle',
  });

  SA.DefineIcon('linkArticleBack', { NAME: 'arrow-left', SVG_KEY: 'back' });
  SA.RegisterCommand('linkArticleBack', {
    title: 'Back',
    undo: false,
    focus: false,
    back: true,
    refreshAfterCallback: false,
    callback: function () {
      this.showArticle.back();
    },
    refresh: function ($btn) {
      var link = this.showArticle.get() && this.doc.hasFocus();
      var $current_image = this.image ? this.image.get() : null;

      if (!$current_image && !link && !this.opts.toolbarInline) {
        $btn.addClass('fr-hidden');
        $btn.next('.fr-separator').addClass('fr-hidden');
      } else {
        $btn.removeClass('fr-hidden');
        $btn.next('.fr-separator').removeClass('fr-hidden');
      }
    },
    plugin: 'showArticle',
  });

  SA.RegisterCommand('linkInsertArticle', {
    focus: false,
    refreshAfterCallback: false,
    callback: function () {
      this.showArticle.insertArticleCallback();
    },
    refresh: function ($btn) {
      var link = this.showArticle.get();

      if (link) {
        $btn.text(this.language.translate('Update'));
      } else {
        $btn.text(this.language.translate('Insert'));
      }
    },
    plugin: 'showArticle',
  });
})(FroalaEditor);
